import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "./body-scroll-lock.js";
import myHelpers from './helpers';

$(document).on("click", ".button--action-modal--open", function(event) {
  event.preventDefault();
  var modalId = $(this).data("modal");
  modalToggle("show", modalId, $(this), $('.button--action-modal--close'));
});

$(".button--action-modal--close, .modal-enquiry-form__overlay").click(function(event) {
  var modalId = $(this).closest('.modal').data("modal");
  modalToggle("hide", modalId, $(this));
});

$(".modal__FocusGuard").focus(function(event) {
  var modalId = $(this).closest('.modal').data("modal");
  modalToggle("hide", modalId);
});

function modalToggle(action, modalId, triggerElement) {
  var transitionEvent = myHelpers.whichTransitionEvent();
  var modal = $(".modal[data-modal=" + modalId + "]");
  if(action === "show") {
    modal.attr("aria-hidden","false").addClass("active");
    var targetElement = document.querySelector('.modal.active .scroll-target');
    disableBodyScroll(targetElement);
    modal.removeClass('hidden--visibility');
    triggerElement.attr("aria-expanded","true").addClass("modal-active");
    modal.one(transitionEvent, function(e) {
    modal.find(".button--action-modal--close").focus();
    });
  } else {
    var targetElement = document.querySelector('.modal.active .scroll-target');
    clearAllBodyScrollLocks();
    modal.attr("aria-hidden","true").removeClass("active"); 
    if(triggerElement) {
      triggerElement.attr("aria-expanded","false");
    }   
    modal.one(transitionEvent, function(e) {
      modal.addClass('hidden--visibility');
      $(".modal-active").focus().attr("aria-expanded","false").removeClass("modal-active");
    });
  }
}

// Escape key closes modals/nav
$(document).keyup(function(e) {
  if (e.keyCode == 27) {
    if($(".modal").hasClass("active")) {
      var modalId = $(".modal.active").data("modal");
      modalToggle("hide", modalId);    
    }
  }
});
